import { render, staticRenderFns } from "./ProfilePageTokenModal.vue?vue&type=template&id=06737826&scoped=true&"
import script from "./ProfilePageTokenModal.vue?vue&type=script&lang=js&"
export * from "./ProfilePageTokenModal.vue?vue&type=script&lang=js&"
import style0 from "./ProfilePageTokenModal.vue?vue&type=style&index=0&id=06737826&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06737826",
  null
  
)

export default component.exports